/**
 * DENET — mobil alt gezinme çubuğu
 *
 * İki sekme kendi başına gezinmiyor, sayfadaki mevcut bileşenleri açıyor:
 * "Menü" başlıktaki mobil çekmeceyi, "Sepet" sepet çekmecesini. Mantığı
 * burada tekrarlamak yerine var olanı tetikliyoruz — çekmecelerin odak
 * yönetimi ve kaydırma kilidi tek yerde kalsın.
 */

import { DenetElement, define, emit, on, EVENTS } from '@denet/core';

class DnTabbar extends DenetElement {
  mounted() {
    this.ref('menu')?.addEventListener('click', () => {
      /** @type {HTMLElement | null} */
      const burger = document.querySelector('[data-ref="burger"]');
      if (burger) burger.click();
      else window.location.href = '/collections';   // çekmece yoksa dizine düş
    }, { signal: this.signal });

    /* Proje listesi bir çekmece, adresi yok: onu açan yüzen düğmeye
       tıklıyoruz. Mantığı burada tekrarlamıyoruz. */
    this.ref('project')?.addEventListener('click', () => {
      /** @type {HTMLElement | null} */
      const fab = document.querySelector('.dn-project__fab');
      if (fab) fab.click();
    }, { signal: this.signal });

    this.ref('cart')?.addEventListener('click', () => {
      if (document.querySelector('dn-cart-drawer')) {
        emit(EVENTS.drawerOpen, { drawer: 'cart' });
      } else {
        window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
      }
    }, { signal: this.signal });

    /* Çekmece açıkken çubuk üstte kalmasın: dialog kendi katmanında ama
       çubuk sabit konumlu, arkadan görünüyordu. */
    const setHidden = (v) => { this.style.visibility = v ? 'hidden' : ''; };
    on(EVENTS.drawerOpen, () => setHidden(true), { signal: this.signal });
    on(EVENTS.drawerClose, () => setHidden(false), { signal: this.signal });
  }
}

define('dn-tabbar', DnTabbar);
